import { styled } from "@material-ui/core";
import { div, Flex } from "lqx-react/lib";
import React from "react";
import { TargetFieldCard } from "../../../api/targetFieldCard";
import { DigiTooltip, limitText } from "../../../shared";
import { MappingItem } from "../../models/import-template-details";

export const StandardSelectOption = ({ mappingItem }
    : { mappingItem: MappingItem, inBlockMappingFields?: TargetFieldCard[] }) => {

    return (
        <Flex row>
            <SourceFileColumn>
                <DigiTooltip title={mappingItem.from.name}>
                    <span>{limitText(mappingItem.from.name, 11)}</span>
                </DigiTooltip>
            </SourceFileColumn>
            <InBlockFieldColumn>
                {mappingItem.to.name}
            </InBlockFieldColumn>
        </Flex>
    );
};

const SourceFileColumn = div({
    flex: '0 0 175px',
    color: '#767D84',
    fontSize: '12px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    alignSelf: 'center',
    padding: '5px 0'
});

const InBlockFieldColumn = styled(SourceFileColumn)({
    flex: '0 0 225px',
})
